import { SponsoredGasCost } from '~/types'

export type FeeAmount = {
  // Undefined when the fee cannot be known, which renders as unavailable
  // rather than as a zero.
  usd: number | undefined
  isEstimate: boolean
}

// The fee a row shows: the pot's charge for a sponsored transaction, the
// gas-field estimate for a self-paid one.
export const getFeeAmount = ({
  isSponsored,
  sponsoredGasCost,
  estimateUsd,
}: {
  isSponsored: boolean
  sponsoredGasCost: SponsoredGasCost | null
  estimateUsd: number | undefined
}): FeeAmount => {
  if (!isSponsored) return { usd: estimateUsd, isEstimate: true }
  if (!sponsoredGasCost) return { usd: undefined, isEstimate: true }
  return { usd: sponsoredGasCost.usd, isEstimate: !sponsoredGasCost.isSettled }
}

// Children of a sponsored Merkle transaction add up only when every child's
// fee is known; one unknown child makes the total unknown.
export const sumFeeAmounts = (fees: FeeAmount[]): FeeAmount => ({
  usd: fees.every((fee) => fee.usd !== undefined)
    ? fees.reduce((total, fee) => total + (fee.usd ?? 0), 0)
    : undefined,
  isEstimate: fees.some((fee) => fee.isEstimate),
})
